import React, { useState } from "react";
import "./Rental_Property_Details.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
    FaMapMarkerAlt,
    FaPhone,
    FaEnvelope,
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";
import Navbar from "../Common Component/Navber";
import RentalFooter from "../Home/Footer";
import PropertyDetail from "../BookingPages/PropertyDetails";

const images = [
    "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85",
    "https://images.unsplash.com/photo-1560185007-cde436f6a4d0",
    "https://images.unsplash.com/photo-1560184897-ae75f418493e",
    "https://images.unsplash.com/photo-1560185127-6ed189bf02f4",
];

const PropertyDetails = () => {
    const [current, setCurrent] = useState(0);
    const navigate = useNavigate();

    const next = () => {
        setCurrent((current + 1) % images.length);
    };

    const prev = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    return (
        <>
        <Navbar/>
        <div className="property-page">

            {/* HEADER */}

       <PropertyDetail/>

            <motion.div className="pd-map-card">
                <iframe
                    title="Map"
                    loading="lazy"
                    src="https://www.openstreetmap.org/export/embed.html?bbox=-0.132%2C51.505%2C-0.09%2C51.52&layer=mapnik"
                />
                <div className="pd-nearby">
                    <strong>Nearby Places</strong>
                    <ul>
                        <li>Metro Station – 5 min</li>
                        <li>Central Park – 10 min</li>
                        <li>City Mall – 15 min</li>
                    </ul>
                </div>
            </motion.div>

        </div>
       <RentalFooter />
        </>
    );
};

export default PropertyDetails;